import React from 'react';
import Button from '../../../../../../../ReactSharedScripts/components/Button';
import FlexGrid from '../../../../../../../ReactSharedScripts/components/FlexGrid';
import { MovingGradient } from '../../../../../../../ReactSharedScripts/components/MovingGradient';
import { codes } from '../../../../../../../ReactSharedScripts/data/translations';
import { getRandomBoundary } from '../../../../../../../ReactSharedScripts/modules/list/listPage/ListLoadingPlaceholder/utils';
import { useTranslationAPI } from '../../../../../../../ReactSharedScripts/modules/translations';
import Spreadsheet, {
	SpreadsheetBody,
	SpreadsheetHead,
	SpreadsheetHeadRow,
} from '../../../../list/components/Spreadsheet';
import { SpreadsheetBodyRowCheckboxLayout } from '../../../../list/components/Spreadsheet/SpreadsheetBodyRowCheckboxLayout';
import { SpreadsheetHeadRowCheckboxLayout } from '../../../../list/components/Spreadsheet/SpreadsheetHeadRowCheckboxLayout';
import { SpreadsheetCardBodyRow } from '../../../../list/components/SpreadsheetCard/SpreadsheetCardBodyRow';
import { SpreadsheetCardBodyRowCheckboxSection } from '../../../../list/components/SpreadsheetCard/SpreadsheetCardBodyRowCheckboxSection';
import { SpreadsheetCardBodyRowContentCard } from '../../../../list/components/SpreadsheetCard/SpreadsheetCardBodyRowContentCard';
import { SpreadsheetCardBodyRowContentSection } from '../../../../list/components/SpreadsheetCard/SpreadsheetCardBodyRowContentSection';

const listItems = Array.from(Array(5).keys());

export const SurveyListItemsPlaceholder: React.FC = () => {
	const { translate } = useTranslationAPI();

	return (
		<Spreadsheet>
			<SpreadsheetHead>
				<SpreadsheetHeadRow>
					<SpreadsheetHeadRowCheckboxLayout disabled />
				</SpreadsheetHeadRow>
			</SpreadsheetHead>
			<SpreadsheetBody>
				{listItems?.map((_, itemId) => {
					return (
						<SpreadsheetCardBodyRow key={itemId}>
							<SpreadsheetCardBodyRowCheckboxSection>
								<SpreadsheetBodyRowCheckboxLayout disabled />
							</SpreadsheetCardBodyRowCheckboxSection>
							<SpreadsheetCardBodyRowContentSection>
								<SpreadsheetCardBodyRowContentCard>
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												gap: '14px',
											}}
										>
											<FlexGrid gap='tiny'>
												<MovingGradient
													height={'20px'}
													width={getRandomBoundary(150, 250, 'px')}
												/>
											</FlexGrid>
											<FlexGrid gap='tiny'>
												{Array.from(Array(2).keys()).map((_, index) => (
													<MovingGradient
														key={index}
														height={'14px'}
														width={getRandomBoundary(120, 200, 'px')}
													/>
												))}
											</FlexGrid>
											<FlexGrid gap='tiny'>
												<MovingGradient
													height={'14px'}
													width={getRandomBoundary(80, 150, 'px')}
												/>
											</FlexGrid>
										</div>
										<div
											style={{
												display: 'grid',
												flexDirection: 'column',
												gap: '14px',
												marginTop: '8px',
											}}
										>
											<MovingGradient
												height={'24px'}
												width={'74px'}
											/>
											<MovingGradient
												height={'16px'}
												width={'60px'}
											/>
										</div>
									</div>
									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
											marginTop: '2px',
										}}
									>
										<div>
											<FlexGrid gap='tiny'>
												{Array.from(Array(3).keys()).map((_, index) => (
													<MovingGradient
														key={index}
														height={'16px'}
														width={getRandomBoundary(50, 150, 'px')}
													/>
												))}
											</FlexGrid>
										</div>
										<div>
											<Button
												size='small'
												disabled
											>
												{translate(codes.common.open)}
											</Button>
										</div>
									</div>
								</SpreadsheetCardBodyRowContentCard>
							</SpreadsheetCardBodyRowContentSection>
						</SpreadsheetCardBodyRow>
					);
				})}
			</SpreadsheetBody>
		</Spreadsheet>
	);
};
